import { useSyncExternalStore } from "react"

/**
 * ¿Cabe el menú lateral fijo? Desde `lg` (1024 px) sí; por debajo —teléfonos y
 * tabletas en vertical— el menú es un cajón que se abre con un botón.
 *
 * ⚠ **Es JavaScript y no una clase `hidden lg:flex`, y no por gusto.** El menú
 * fijo comparte `layoutId` con la tarjeta del acceso: al entrar, la tarjeta VIAJA
 * hasta convertirse en él. Escondido con CSS seguiría montado con una caja de
 * cero píxeles, y motion haría viajar la tarjeta hasta un punto. Aquí, en el
 * teléfono, el menú fijo sencillamente no existe y la tarjeta se desvanece.
 *
 * ⚠ **Sin `matchMedia` —jsdom, las pruebas— cuenta como pantalla ancha**, que es
 * como se comportaba todo antes de que hubiera cajón.
 */
const CONSULTA = "(min-width: 1024px)"

function suscribir(avisar: () => void) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return () => {}
  const lista = window.matchMedia(CONSULTA)
  lista.addEventListener("change", avisar)
  return () => lista.removeEventListener("change", avisar)
}

function leer() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return true
  return window.matchMedia(CONSULTA).matches
}

// ⚠ `use` y no `usar`: como `useFotoPersona`, es el prefijo por el que React y
// Biome reconocen un hook y vigilan que no se llame dentro de un `if`.
export function usePantallaAncha() {
  return useSyncExternalStore(suscribir, leer, () => true)
}
